/*** PAR Modules ***/
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Http, HttpModule, Headers } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { RouterTestingModule } from '@angular/router/testing';
import { SortPipe } from '../shared/sortPipe';
import { ChartModule } from 'angular2-chartjs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule, MatPaginatorModule, MatButtonModule, MatCheckboxModule, MatTableModule, MatInputModule,
         MatSelectModule, MatToolbarModule, MatMenuModule, MatIconModule, MatFormFieldModule, MatTabsModule,
         MatDialogModule, MatTooltipModule, MatDatepickerModule, MatNativeDateModule, MatSliderModule, MatProgressSpinnerModule, DateAdapter, MatAutocompleteModule, MatChipsModule} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { JwtModule } from '@auth0/angular-jwt';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FileDropModule } from 'ngx-file-drop';
import { LinkyModule } from 'angular-linky';
import {MatRadioModule} from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { ChartsModule } from 'ng2-charts';

/*** PAR Components ***/
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MasterComponent } from './components/master/master.component';
import { AgentsearchlistComponent } from './components/agentsearchlist/agentsearchlist.component';
import { AppComponent } from './app.component';
import { PAREmployeeComponent } from './components/par_employees/par_employees.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { ParButtonComponent } from './par-library/form-components/par-button/par-button.component';
import { AgentSummaryComponent } from './components/agent-summary/agent-summary.component';
import { AgentInsuranceComponent } from './components/agent-insurance/agent-insurance.component';
import { AgentlocationComponent } from './components/agentlocation/agentlocation.component';
import { AgentlocationService } from './services/agent_location/agentlocation.service';
import { AgentInsuranceDialogComponent } from './components/agent-insurance-dialog/agent-insurance-dialog.component';
import { NavTabComponent } from './components/nav-tab/nav-tab.component';
import { LocationsummaryComponent } from './components/locationsummary/locationsummary.component';
import { StaterequirementsComponent } from './components/staterequirements/staterequirements.component';
import { AgentDueDiligenceComponent } from './components/agent-due-diligence/agent-due-diligence.component';
import { DueDiligenceDialogComponent } from './components/due-diligence-dialog/due-diligence-dialog.component';
import { StateRequirementRepossessionComponent } from './components/state-requirement-repossession/state-requirement-repossession.component';
import { StateRequirementPrerepossessionComponent } from './components/state-requirement-prerepossession/state-requirement-prerepossession.component';
import { StateRequirementPostrepossessionComponent } from './components/state-requirement-postrepossession/state-requirement-postrepossession.component';
import { StateRequirementStoragefeeComponent } from './components/state-requirement-storagefee/state-requirement-storagefee.component';
import { StateRequirementPersonalpropertyComponent } from './components/state-requirement-personalproperty/state-requirement-personalproperty.component';
import { StateRequirementPersonalproperty1Component } from './components/state-requirement-personalproperty1/state-requirement-personalproperty1.component';
import { UploadControlComponent } from './components/upload-control/upload-control.component';
import { UploadControlTestComponent } from './components/upload-control-test/upload-control-test.component';
import { LocationnavtabComponent } from './components/locationnavtab/locationnavtab.component';
import { AgentlocationdocumentsComponent } from './components/agentlocationdocuments/agentlocationdocuments.component';
import { InsuranceDocsClearDialogComponent } from './components/insurance-docs-clear-dialog/insurance-docs-clear-dialog.component';
import { DueDiligenceDeleteDialogComponent } from './components/due-diligence-delete-dialog/due-diligence-delete-dialog.component';
import { AgentLocationdocsDialogComponent } from './components/agent-locationdocs-dialog/agent-locationdocs-dialog.component';
import { AgentLocationdocsDeleteDialogComponent } from './components/agent-locationdocs-delete-dialog/agent-locationdocs-delete-dialog.component';
import { AgentLicenseComponent } from './components/agent-license/agent-license.component';
import { AgentDashboardComponent } from './components/agent-dashboard/agent-dashboard.component';
import { LicenseDialogueComponent } from './components/license-dialogue/license-dialogue.component';
import { ContactUsDialogComponent } from './components/contact-us-dialog/contact-us-dialog.component';
import { DownloadControlTestComponent } from './components/download-control-test/download-control-test.component';
import { DownloadControlComponent } from './components/download-control/download-control.component';
import { AgentEmployeeComponent } from './components/agent-employee/agent-employee.component';
import { EmployeeNavtabComponent } from './components/employee-navtab/employee-navtab.component';
import { EmployeeSummaryComponent } from './components/employee-summary/employee-summary.component';
import { EmployeeDocumentsComponent } from './components/employee-documents/employee-documents.component';
import { AddAgentEmployeeDialogComponent } from './components/add-agent-employee-dialog/add-agent-employee-dialog.component';
import { ParEmployeeComponent } from './components/par-employee/par-employee.component';
import { ParemployeeSummaryComponent } from './components/paremployee-summary/paremployee-summary.component';
import { ParemployeeNavtabComponent } from './components/paremployee-navtab/paremployee-navtab.component';
import { ParemployeeDelDialogComponent } from './components/paremployee-del-dialog/paremployee-del-dialog.component';
import { ParInsuranceDocumentComponent } from './components/par-insurance/par-insurance-document/par-insurance-document.component';
import { ParDashboardComponent } from './components/par-dashboard/par-dashboard.component';
import { ParNavTabComponent } from './components/par-nav-tab/par-nav-tab.component';
import { ParInsuranceDialogueComponent } from './components/par-insurance/par-insurance-dialogue/par-insurance-dialogue.component';
import { ParemployeeSummaryTabComponent } from './components/paremployee-summary-tab/paremployee-summary-tab.component';
import { ParemployeeDocumentsTabComponent } from './components/paremployee-documents-tab/paremployee-documents-tab.component';
import { ParemployeeDocumentUploadDialogComponent } from './components/paremployee-document-upload-dialog/paremployee-document-upload-dialog.component';
import { DeleteAgentEmployeeDialogComponent } from './components/delete-agent-employee-dialog/delete-agent-employee-dialog.component';
import { SubmasterComponent } from './components/submaster/submaster.component';
import { AgentEmployeeDocsDialogComponent } from './components/agent-employee-docs-dialog/agent-employee-dialog.component';
import { AgentEmployeeDocsDeleteDialogComponent } from './components/agent-employee-docs-delete-dialog/agent-employee-delete-dialog.component';
import { ClientAgentsListComponent } from './components/client-agents-list/client-agents-list.component';
import { ParNavComponent } from './components/par-nav/par-nav.component';
import { TermsAndConditionsDialogComponent } from './components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { ParsummaryComponent } from './components/parsummary/parsummary.component';
import { ParemployeeSummaryForParComponent } from './components/paremployee-summary-for-par/paremployee-summary-for-par.component';
import { ParDueDiligenceDeleteDialogComponent } from './components/par-due-diligence/par-due-diligence-delete-dialog/par-due-diligence-delete-dialog.component';
import { ParLicneseDocumnetComponent } from './components/par-license/par-licnese-documnet/par-licnese-documnet.component';
import { ParLicenseDialogueComponent } from './components/par-license/par-license-dialogue/par-license-dialogue.component';
import { ParemployeeDocumentDeleteDialogComponent } from './components/paremployee-document-delete-dialog/paremployee-document-delete-dialog.component';
import { ParDueDiligenceComponent } from './components/par-due-diligence/par-due-diligence-documents/par-due-diligence.component';
import { ParDueDiligenceDialogComponent } from './components/par-due-diligence/par-due-diligence-dialog/par-due-diligence-dialog.component';
import { ChangeLogComponent } from './components/change-log/change-log.component';
import { DatexPipe } from './components/date-formatter.pipe';
import { LocationRoutesComponent } from './components/location-routes/location-routes.component';
import { EmployeeRoutesComponent } from './components/employee-routes/employee-routes.component';
import { ParemployeeRoutesComponent } from './components/paremployee-routes/paremployee-routes.component';
import { NewComplaintsDialogComponent } from './components/new-complaints-dialog/new-complaints-dialog.component';
import { ManageComplaintViewtasksDialogComponent } from './components/manage-complaint-viewtasks-dialog/manage-complaint-viewtasks-dialog.component';
import { ManageComplaintsComponent } from './components/manage-complaints/manage-complaints.component';
import { ManageComplaintDeleteDailogueComponent } from './components/manage-complaint-delete-dailogue/manage-complaint-delete-dailogue.component';
import { ManageComplaintsEdittaskComponent } from './components/manage-complaints-edittask/manage-complaints-edittask.component';
import { UploadMultipleDocumentsComponent } from './components/upload-multiple-documents/upload-multiple-documents.component';
import { DownloadMultipleDocumentsComponent } from './components/download-multiple-documents/download-multiple-documents.component';
import { VendorComplaintDocumentsComponent } from './components/vendor-complaint-documents/vendor-complaint-documents.component';

/*** PAR Services ***/
import { UserDataService } from './services/user/userData.service';
import { RoleGuardService } from './security/role-guard.service';
import { AgentEmployeeService } from '../../src/app/services/agent-employee/agent-employee.service';
import { AgentDashboardService } from '../../src/app/services/agent_dashboard/agent-dashboard.service';
import { ParEmployeeService } from './services/par_employees/par_employees.service';
import { ParInsuranceService } from './services/par_insurance/par-insurance.service';
import { LocationdocumentsService } from './services/locationdocuments/locationdocuments.service';
import { DownloadService } from './services/download/download.service';
import { LicenseDataService } from './services/agentLicense/license-data.service';
import { UploadService } from './services/upload/upload.service';
import { StatesService } from './services/states/states.service';
import { DueDiligenceService } from './services/due-diligence/due-diligence.service';
import { StateRequirementService } from './services/state_requirements/staterequirements.service';
import { InsuranceService } from './services/insurance/insurance.service';
import { UserService } from './services/user/user.service';
import { RegionService } from './services/region/region.service';
import { SearchTermservice } from '../app/services/search/search-service.service';
import { ParLicenseService } from './services/par_license/par-license.service';
import { ParDueDiligenceService } from './services/par-due-diligence/par-due-diligence.service';
import { ChangeLogService } from './services/change_log/change-log.service';
import { ParDashboardService } from './services/par-dashboard/par-dashboard.service';
import { MaindashboardService } from './services/maindashboard/maindashboard.service';
import { UserFriendlyMsgs } from './app.user-msgs';
import { GoogleAnalyticsService } from './services/google_analytics/google-analytics.service';
import { ManageComplaintsService } from './services/manage-complaints/manage-complaints.service';
import { ComplaintsDropDownService } from './services/complaints_drop_down/complaints-drop-down.service';
import { ManageUsersComponent } from './components/manage-users/manage-users.component';
import { ManageUsersService } from './services/manage-users/manage-users.service';
import { ManageUsersDialogComponent } from './components/manage-users-dialog/manage-users-dialog.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { jsoncomparator } from '../shared/JSONcomparator'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './security/token.interceptor';
import { NonceInterceptor } from './security/nonce.interceptor';
import { ManageUserDeleteDialogueComponent } from './components/manage-user-delete-dialogue/manage-user-delete-dialogue.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { PasswordService } from './services/password/password.service';
import { SuccessdialogComponent } from './components/successdialog/successdialog.component';
import { VendorsearchService } from './services/vendor/vendorsearch.service';
import { GetDocStatusByRole} from '.././shared/globalService';
import { GetDocStatusColor } from '.././shared/globalService';
import { DisableRow } from '.././shared/globalService';
import { PendingApprovalDialogComponent } from './components/pending-approval-dialog/pending-approval-dialog.component';
import { ApproveRejectDialogComponent } from './components/approve-reject-dialog/approve-reject-dialog.component';
import { AddTaskComponent } from './components/add-task/add-task.component';
import { ParComplaintsTasksService } from './services/par_complaints_tasks/par-complaints-tasks.service';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComplaintsDashboardService } from './services/complaints_dashboard/complaints-dashboard.service';
import { ParComplaintsDocumentsComponent } from './components/par-complaints-documents/par-complaints-documents.component';
import { ParComplaintsDocumentsService } from './services/par-complaints-documents/par-complaints-documents.service';
import { parComplaintsTasksDelDialog } from './components/par-complaints-tasks-del-dialog/par-complaints-tasks-del-dialog.component';
import { ManageComplaintViewDocumentsDialogueComponent } from './components/manage-complaint-view-documents-dialogue/manage-complaint-view-documents-dialogue.component';
import { ParComplaintsDocumentDeleteDialogComponent } from './components/par-complaints-document-delete-dialog/par-complaints-document-delete-dialog.component';
import { from } from 'rxjs/observable/from';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ManageComplaintTimelineDialogComponent } from './components/manage-complaint-timeline-dialog/manage-complaint-timeline-dialog.component';
import { ParComplaintsTimelineService } from './services/par-complaints-timeline/par-complaints-timeline.service';
import { ParComplaintsRegionStateMappingComponent } from './components/par-complaints-region-state-mapping/par-complaints-region-state-mapping.component';
import { ParComplaintsRegionstatemapService } from './services/par-complaints-regionstatemap/par-complaints-regionstatemap.service';
import { AgentChecklistComponent } from './components/agent-checklist/agent-checklist.component';
import { VendorComplaintsComponent } from './components/vendor-complaints/vendor-complaints.component';
import { VendorComplaintsService } from './services/vendor-complaints/vendor-complaints.service';
import { LocationChecklistService } from './services/location-checklist/location-checklist.service';
import { SharedVals } from '../shared/SharedVals';
import { OKTA_CONFIG, OktaAuthModule, OktaAuthService } from '@okta/okta-angular';
import { LogoutComponent } from './components/logout/logout.component';
import { environment } from '../environments/environment';
import { OktaCustomCallbackComponent } from './components/okta-custom-callback/okta-custom-callback.component';
import { NonceService } from './services/nonce.service';

const oktaConfig = {
  issuer: environment.okta.issuerURL,
  clientId: environment.okta.clientId,
  redirectUri: environment.okta.redirectURI,
  postLogoutRedirectUri: environment.okta.endSessionRedirectURI,
  scopes: environment.okta.scopes,
  pkce: environment.okta.pkce
}

@NgModule({
  declarations: [
    AppComponent,
    PAREmployeeComponent,
    HomeComponent,
    LoginComponent,
    LogoutComponent,
    ParButtonComponent,
    DashboardComponent,
    HeaderComponent,
    FooterComponent,
    MasterComponent,
    AgentsearchlistComponent,
    SortPipe,
    AgentSummaryComponent,
    AgentInsuranceComponent,
    AgentInsuranceDialogComponent,
    AgentlocationComponent,
    NavTabComponent,
    LocationsummaryComponent,
    StaterequirementsComponent,
    AgentDueDiligenceComponent,
    DueDiligenceDialogComponent,
    StateRequirementRepossessionComponent,
    StateRequirementPrerepossessionComponent,
    StateRequirementPostrepossessionComponent,
    StateRequirementStoragefeeComponent,
    StateRequirementPersonalpropertyComponent,
    StateRequirementPersonalproperty1Component,
    UploadControlComponent,
    UploadControlTestComponent,
    InsuranceDocsClearDialogComponent,
    DueDiligenceDeleteDialogComponent,
    LocationnavtabComponent,
    AgentlocationdocumentsComponent,
    InsuranceDocsClearDialogComponent,
    AgentLicenseComponent,
    AgentDashboardComponent,
    AgentLocationdocsDialogComponent,
    AgentLocationdocsDeleteDialogComponent,
    // StateRequirementsReadonlyComponent,
    LicenseDialogueComponent,
    ContactUsDialogComponent,
    AgentLocationdocsDeleteDialogComponent,
    DownloadControlTestComponent,
    DownloadControlComponent,
    LicenseDialogueComponent,
    AgentEmployeeComponent,
    EmployeeNavtabComponent,
    EmployeeSummaryComponent,
    EmployeeDocumentsComponent,
    AddAgentEmployeeDialogComponent,
    ParEmployeeComponent,
    ParemployeeSummaryComponent,
    ParemployeeNavtabComponent,
    ParemployeeDelDialogComponent,
    ParInsuranceDocumentComponent,
    ParDashboardComponent,
    ParNavTabComponent,
    ParInsuranceDialogueComponent,
    ParemployeeSummaryTabComponent,
    ParemployeeDocumentsTabComponent,
    ParemployeeDocumentUploadDialogComponent,
    DeleteAgentEmployeeDialogComponent,
    SubmasterComponent,
    ClientAgentsListComponent,
    ParNavComponent,
    AgentEmployeeDocsDialogComponent,
    AgentEmployeeDocsDeleteDialogComponent,
    ClientAgentsListComponent,
    ParLicneseDocumnetComponent,
    ParLicenseDialogueComponent,
    ParemployeeDocumentDeleteDialogComponent,
    ParDueDiligenceComponent,
    ParDueDiligenceDialogComponent,
    ChangeLogComponent,
    TermsAndConditionsDialogComponent,
    ParsummaryComponent,
    ParemployeeSummaryForParComponent,
    ParDueDiligenceDeleteDialogComponent,
    DatexPipe,
    LocationRoutesComponent,
    EmployeeRoutesComponent,
    ParemployeeRoutesComponent,
    ManageUsersComponent,
    ManageUsersDialogComponent,
    ManageUserDeleteDialogueComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    SuccessdialogComponent,
    PendingApprovalDialogComponent,
    ApproveRejectDialogComponent,
    ManageComplaintsComponent,
    AddTaskComponent,
    NewComplaintsDialogComponent,
    ManageComplaintDeleteDailogueComponent,
    ManageComplaintViewtasksDialogComponent,
    ParComplaintsDocumentsComponent,
    ManageComplaintViewDocumentsDialogueComponent,
    parComplaintsTasksDelDialog,
    ParComplaintsDocumentDeleteDialogComponent,
    ManageComplaintsEdittaskComponent,
    ManageComplaintViewDocumentsDialogueComponent,
    ManageComplaintTimelineDialogComponent,
    UploadMultipleDocumentsComponent,
    VendorComplaintsComponent,
    DownloadMultipleDocumentsComponent,
    ParComplaintsRegionStateMappingComponent,
    AgentChecklistComponent,
    VendorComplaintDocumentsComponent,
    OktaCustomCallbackComponent
  ],
  imports: [MatNativeDateModule, MatSliderModule, CurrencyMaskModule,
    BrowserModule,
    Ng2SmartTableModule,
    // UserIdleModule.forRoot({idle: environment.browserIdleTime, timeout:environment.timeOut, ping: environment.ping}),
    FlexLayoutModule,
    HttpClientModule,
    MatExpansionModule,
    ChartModule,
    MatDialogModule,
    MatSelectModule,
    MatMenuModule,
    MatTabsModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([]),
    HttpModule,
    AppRoutingModule,
    RouterTestingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatSortModule,
    MatPaginatorModule,
    MatTableModule,
    MatToolbarModule,
    MatAutocompleteModule,
    FileDropModule,
    MatCardModule,
    NgCircleProgressModule.forRoot(),
    LinkyModule,
    MatRadioModule,
    ChartsModule,
    OktaAuthModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NonceInterceptor,
      multi: true,
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: OKTA_CONFIG, useValue: oktaConfig },
    NonceService,
    ParEmployeeService,
    UserFriendlyMsgs,
    LicenseDataService,
    OktaAuthService,
    UserDataService,
    UserService,
    SearchTermservice,
    RegionService,
    RoleGuardService,
    InsuranceService,
    AgentlocationService,
    StatesService,
    StateRequirementService,
    UploadService,
    DownloadService,
    DueDiligenceService,
    LocationdocumentsService,
    AgentEmployeeService,
    AgentDashboardService,
    ParInsuranceService,
    ParLicenseService,
    ParDueDiligenceService,
    ChangeLogService,
    MaindashboardService,
    ParDashboardService,
    GoogleAnalyticsService,
    ManageUsersService,
    ComplaintsDashboardService,
    jsoncomparator,
    PasswordService,
    VendorsearchService,
    GetDocStatusByRole,
    GetDocStatusColor,
    DisableRow,
    ParComplaintsTasksService,
    ComplaintsDropDownService,
    ManageComplaintsService,
    ParComplaintsDocumentsService,
    ParComplaintsTimelineService,
    VendorComplaintsService,
    ParComplaintsRegionstatemapService,
    LocationChecklistService,
    SharedVals
  ],
  entryComponents: [
      AgentInsuranceDialogComponent,
      InsuranceDocsClearDialogComponent,
      DueDiligenceDialogComponent,
      DueDiligenceDeleteDialogComponent,
      AgentLocationdocsDialogComponent,
      AgentLocationdocsDeleteDialogComponent,
      ContactUsDialogComponent,
      LicenseDialogueComponent,
      ParemployeeSummaryComponent,
      ParemployeeDelDialogComponent,
      AddAgentEmployeeDialogComponent,
      ParDueDiligenceDialogComponent,
      ParDueDiligenceDeleteDialogComponent,
      ParInsuranceDialogueComponent,
      AddAgentEmployeeDialogComponent,
      ParemployeeDocumentUploadDialogComponent,
      DeleteAgentEmployeeDialogComponent,
      AgentEmployeeDocsDialogComponent,
      AgentEmployeeDocsDeleteDialogComponent,
      ParemployeeDocumentUploadDialogComponent,
      ParemployeeDocumentDeleteDialogComponent,
      ParLicenseDialogueComponent,
      TermsAndConditionsDialogComponent,
      ManageUsersDialogComponent,
      ManageUserDeleteDialogueComponent,
      PendingApprovalDialogComponent,
      ApproveRejectDialogComponent,
      AddTaskComponent,
      NewComplaintsDialogComponent,
      ManageComplaintDeleteDailogueComponent,
      ManageComplaintViewtasksDialogComponent,
      ParComplaintsDocumentsComponent,
      ManageComplaintsEdittaskComponent,
      ManageComplaintViewDocumentsDialogueComponent,
      parComplaintsTasksDelDialog,
      ParComplaintsDocumentDeleteDialogComponent,
      ManageComplaintTimelineDialogComponent,
      ParComplaintsRegionStateMappingComponent,
      VendorComplaintDocumentsComponent
    ],
  bootstrap: [AppComponent]
})

export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts